var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "header-cell table-cell",
      class: {
        "is-sorted": _vm.sortDirection != _vm.SortDirection.None,
        "is-sortable": _vm.field.is_sortable,
      },
      on: { click: _vm.sort },
    },
    [
      _c("div", { staticClass: "header-cell-content" }, [
        _c(
          "div",
          {
            ref: "fieldLabel",
            staticClass: "field-name",
            attrs: { title: _vm.sortTooltip },
          },
          [_vm._v(_vm._s(_vm.field.label))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "field-actions" }, [
          _vm.filters.length > 0
            ? _c(
                "div",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "bulma-icon",
                    {
                      staticClass: "filter-toggle",
                      class: { "is-expanded": _vm.showFilters },
                      attrs: {
                        name: "fas fa-filter",
                        title: _vm.filtersTooltip,
                      },
                      on: {
                        click: function ($event) {
                          _vm.showFilters = !_vm.showFilters
                        },
                      },
                    },
                    [
                      _vm.isAnyFilterActive
                        ? _c("icon", {
                            staticClass: "active-filter-indicator",
                            attrs: { name: "fas fa-cog" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "filters" } }, [
                    _c(
                      "div",
                      { class: { "filters-container": _vm.showFilters } },
                      _vm._l(_vm.filters, function (filter, index) {
                        return _c(filter.name, {
                          key: index,
                          tag: "component",
                          attrs: {
                            isVisible: _vm.showFilters,
                            field: _vm.field,
                            options: filter,
                            prefix: _vm.prefix,
                          },
                          on: {
                            filter: _vm.onFilter,
                            active: _vm.onFilterBecomeActive,
                            inactive: _vm.onFilterBecomeInactive,
                          },
                        })
                      }),
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "sort-actions" }, [
            _vm.field.is_sortable
              ? _c(
                  "button",
                  {
                    ref: "sortButton",
                    staticClass: "button sort-button",
                    class: {
                      "is-loading": _vm.isLoading || _vm.isTableLoading,
                    },
                    attrs: {
                      title: _vm.sortTooltip,
                      disabled: _vm.isLoading || _vm.isTableLoading,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.sort.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.sortDirection == _vm.SortDirection.Asc
                      ? _c(
                          "span",
                          { staticClass: "icon icon-sort-asc" },
                          [
                            _c("icon", {
                              attrs: { name: "fas fa-chevron-down" },
                            }),
                          ],
                          1
                        )
                      : _vm.sortDirection == _vm.SortDirection.Desc
                      ? _c(
                          "span",
                          { staticClass: "icon icon-sort-desc" },
                          [
                            _c("icon", {
                              attrs: { name: "fas fa-chevron-up" },
                            }),
                          ],
                          1
                        )
                      : _vm.field.is_sortable
                      ? _c(
                          "span",
                          { staticClass: "icon icon-no-sort-active" },
                          [_c("icon", { attrs: { name: "fas fa-sort" } })],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.field.is_sortable && _vm.sortDirection != _vm.SortDirection.None
            ? _c(
                "button",
                {
                  ref: "clearSortButton",
                  staticClass: "button sort-button clear-sort is-small",
                  attrs: {
                    title: _vm.clearSortTooltip,
                    disabled: _vm.isLoading || _vm.isTableLoading,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.removeSort.apply(null, arguments)
                    },
                  },
                },
                [_c("bulma-icon", { attrs: { name: "fas fa-times" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMultiSort && _vm.sortDirection != _vm.SortDirection.None
            ? _c(
                "div",
                {
                  staticClass: "sort-order-index",
                  attrs: { title: _vm.$gettext("Sort order number") },
                },
                [_vm._v(_vm._s(_vm.getSortIndex(_vm.field) + 1))]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }